/**
 * Form-level / API error banner — sanitizes at RENDER (defense-in-depth).
 * Prefer already-sanitized / i18n messages at setFormError; never show raw
 * developer strings (Invalid JSON, HTTP 500, stacks) even if state is polluted.
 */
import { useTranslation } from 'react-i18next';
import { toCustomerFacingErrorMessage } from '../../../shared/errors/toCustomerFacingErrorMessage.js';

export interface AuthFormErrorBannerProps {
  readonly message: string | undefined;
  readonly testId?: string;
}

export function AuthFormErrorBanner(
  props: AuthFormErrorBannerProps,
): JSX.Element | null {
  const { t } = useTranslation('customer');
  if (props.message === undefined) {
    return null;
  }
  const publicFallback = t('errors.generic');
  return (
    <p
      className="text-sm text-[var(--color-danger)]"
      role="alert"
      data-testid={props.testId}
    >
      {toCustomerFacingErrorMessage(props.message, { fallback: publicFallback })}
    </p>
  );
}
